import React from "react";
import { useNavigate } from "react-router-dom";
import { FooterLogoIcon } from "../common/Icons";
import { FooterIcon, FooterValues } from "./Helper";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="bg-light-white">
        {" "}
        <div className="container py-4">
          <div className="row justify-content-between align-items-center px-3 px-sm-0">
            <div className="col-lg-auto">
              <h6 className="font-xs font-normal text-center text-lg-start mb-0">
                Get news and updates
              </h6>
            </div>
            <div className="col-lg-auto my-2 my-md-2 my-lg-0 ">
              <h6 className="font-xxs font-normal color-black text-center text-lg-start opacity-07 mb-0">
                Sign up for the latest news on how we are shaping a new future.{" "}
              </h6>
            </div>
            <div className="col-12 col-lg-5 col-xl-6 d-flex justify-between input-common-clases p-1">
              <form className="w-100 d-flex">
                <input
                  type="email"
                  placeholder="Email address"
                  name=""
                  id=""
                  required
                  className="w-100 border-0 p-0 bg-transparent ps-3"
                />
                <button
                  type="submit"
                  className="sign-up-btn color-white font-xs text-nowrap font-medium"
                >
                  SIGN UP
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className="footer_bg pt-5">
        <div className="container-fluid px-5 pt-lg-4">
          <div className="text-center">
            <span onClick={() => navigate("/")} className="coursor-pointer">
              <FooterLogoIcon />
            </span>
          </div>
          <div className=" d-flex justify-content-center mt-sm-5 mt-3 flex-sm-row flex-column">
            {FooterValues.map((val, i) => {
              return (
                <span
                  key={i}
                  className="text-white d-inline-block mx-3 cursor-pointer font-sm pt-sm-0 pt-3 text-sm-start text-center"
                >
                  <a
                    className="color-wwhite text-decoration-none footer_link position-relative"
                    href="/"
                  >
                    {val.text}
                  </a>
                </span>
              );
            })}
          </div>
          <div className="footer_bg_line mt-5"></div>
          <div className=" d-flex justify-content-between align-items-center flex-sm-row flex-column">
            <a
              href="#"
              className="text-white font-sm pt-sm-0 pt-3 text-decoration-none position-relative"
            >
              Follow us :
            </a>
            <div className="d-flex mt-sm-5 my-4">
              {FooterIcon.map((val, i) => {
                return (
                  <a
                    href={val.link}
                    className="footer_icon_hover transition_03s"
                    key={i}
                  >
                    <span className="d-inline mx-1 ">{val.img}</span>
                  </a>
                );
              })}
            </div>
          </div>
          <div className="d-flex flex-xl-row flex-column justify-content-between pb-4 align-items-center pt-3">
            <div className="d-flex justify-content-center">
              <a
                href="#"
                className="text-white font-sm text-decoration-none footer_link position-relative"
              >
                Privacy policy
              </a>
              <a
                href="#"
                className="mx-3 text-white font-sm text-decoration-none footer_link position-relative"
              >
                Terms of use
              </a>
              <a
                href="#"
                className="text-white font-sm text-decoration-none footer_link position-relative"
              >
                Cookie policy
              </a>
            </div>
            <div className="pt-xl-0 pt-4 d-flex flex-sm-row flex-column justify-content-between">
              <span className="color-light-white font-xxs opacity-07 me-sm-5 text-sm-start text-center">
                @ 2022 Cyboryx
              </span>
              <span className="color-light-white font-xxs opacity-07 pt-sm-0 pt-3 text-sm-start text-center">
                This site is protected by reCAPTCHA and the google a privacy
                policy and terms of service apply.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
